import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { LogoComponent } from '@core/layout/components/logo/logo.component';
import { MenuContentComponent } from '@core/layout/components/menu-content/menu-content.component';
import { UsuarioLogadoMobileSidebarComponent } from '@core/layout/components/mobile-sidebar/usuario-logado-mobile-sidebar/usuario-logado-mobile-sidebar.component';
import { TenantLogadoNavbarComponent } from '@core/layout/components/navbar/tenant-logado-navbar/tenant-logado-navbar.component';
import { MenuService } from '@core/layout/services/menu.service';
import { IconComponent } from '@shared/components/icon/icon.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';

@Component({
  selector: 'app-mobile-sidebar',
  imports: [
    NgClass,
    MenuContentComponent,
    LogoComponent,
    IconComponent,
    AppButtonDirective,
    UsuarioLogadoMobileSidebarComponent,
    TenantLogadoNavbarComponent,
  ],
  templateUrl: './mobile-sidebar.component.html',
  styleUrl: './mobile-sidebar.component.scss',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class MobileSidebarComponent implements OnInit {
  menuService = inject(MenuService);


  ngOnInit(): void {
    // Garantir que o menu está fechado ao iniciar em dispositivos móveis
    if (window.innerWidth < 768) {
      this.menuService.showMobileMenu = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.menuService.showMobileMenu) {
      this.menuService.showMobileMenu = false;
    }
  }

  closeMobileMenu(event: MouseEvent): void {
    // Close when clicking outside
    if (event.target === event.currentTarget) {
      this.menuService.showMobileMenu = false;
    }
  }

  onMenuItemClick(): void {
    // Close mobile menu when a menu item is clicked
    this.menuService.showMobileMenu = false;
  }
}
